(function (window, document, $) {
  $(document).ready(function () {


    $("input[data-type='currency']").on({
      keyup: function () {
        formatCurrency($(this));
      },
      blur: function () {
        formatCurrency($(this), "blur");
      }
    });


    function formatNumber(n) {
      // format number 1000000 to 1,234,567
      return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }


    function formatCurrency(input, blur) {
      // appends $ to value, validates decimal side
      // and puts cursor back in right position.

      // get input value
      var input_val = input.val();

      // don't validate empty input
      if (input_val === "") { return; }

      // original length
      var original_len = input_val.length;

      // initial caret position
      var caret_pos = input.prop("selectionStart");

      // check for decimal
      if (input_val.indexOf(".") >= 0) {

        // get position of first decimal
        // this prevents multiple decimals from
        // being entered
        var decimal_pos = input_val.indexOf(".");

        // split number by decimal point
        var left_side = input_val.substring(0, decimal_pos);
        var right_side = input_val.substring(decimal_pos);

        // add commas to left side of number
        left_side = formatNumber(left_side);

        // validate right side
        right_side = formatNumber(right_side);

        // On blur make sure 2 numbers after decimal
        if (blur === "blur") {
          right_side += "00";
        }

        // Limit decimal to only 2 digits
        right_side = right_side.substring(0, 2);

        // join number by .
        input_val = "$" + left_side + "." + right_side;

      } else {
        // no decimal entered
        // add commas to number
        // remove all non-digits
        input_val = formatNumber(input_val);
        input_val = "$" + input_val;

        // final formatting
        if (blur === "blur") {
          input_val += ".00";
        }
      }

      // send updated string to input
      input.val(input_val);

      // put caret back in the right position
      var updated_len = input_val.length;
      caret_pos = updated_len - original_len + caret_pos;
      input[0].setSelectionRange(caret_pos, caret_pos);
    }

    function isBetween(n, a, b) {
      return (n - a) * (n - b) <= 0
    }

    function monthlyPayment(p, n, i) {
      return p * i * (Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
    }

    $('.lightstream-rate-button').on("click", function (e) {
      e.preventDefault();

      $('.lightstream-rate-form-message').html("");

      var rateAmount = $('.lightstream-rate-input').val();
      //console.log("Rate Amount: " + rateAmount);

      var modAmount = rateAmount.replace(/[$,]+/g, "");
      //console.log('Normalized Amount: ' + modAmount);

      var rateType = $('.lightstream-rate-type-selection').find(":selected").text();
      //console.log("Rate Type: " + rateType);

      if (isBetween(modAmount, 5000, 100000)) {
        var amountValidated = true;
      } else {
        var amountValidated = false;
      }

      if (rateType.length > 0 && rateType != "Select Loan Purpose") {
        var typeValidated = true;
      } else {
        var typeValidated = false;
      }

      if ((amountValidated === true) && (typeValidated == true)) {

        $('.lightstream-loader').css('display', 'block');

        // Normalize Values for Ajax
        rateTypeVar = $('.lightstream-rate-type-selection').find(":selected").val();
        var modAmountVar = Math.floor(modAmount);

        // 36 Months
        $.ajax({
          type: "POST",
          url: "https://www.tayloegray.com/ls/feed.php",
          dataType: "json",
          data: {
            term: "36",
            purpose: rateTypeVar,
            amount: modAmountVar
          },
          success: function (result) {
            if (result.IsValid == "true") {
              var thirtySixPayment = Math.round(result.EstimatedMonthPayment.From);
              var thirtySixAPR = (result.Rate.From * 100).toFixed(2);
              $('div.thirty-six-month .payment-amount').find('strong').text(thirtySixPayment);
              $('div.thirty-six-month .apr').find('span').text(thirtySixAPR);
              $("div.thirty-six-month").animate({
                opacity: 1,
              }, 200, function () {
                $('.thirty-six-month').parent('div').removeClass('d-none');
              });
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            //console.log("36mo. Status: " + textStatus); alert("Error: " + errorThrown);
          },
          complete: function (data) {
            $('.lightstream-loader').css('display', 'none');
          }
        });


        // 48 Months
        $.ajax({
          type: "POST",
          url: "https://www.tayloegray.com/ls/feed.php",
          dataType: "json",
          data: {
            term: "48",
            purpose: rateTypeVar,
            amount: modAmountVar
          },
          success: function (result) {
            if (result.IsValid == "true") {
              var fourtyEightPayment = Math.round(result.EstimatedMonthPayment.From);
              var fourtyEightAPR = (result.Rate.From * 100).toFixed(2);
              $('div.fourty-eight-month .payment-amount').find('strong').text(fourtyEightPayment);
              $('div.fourty-eight-month .apr').find('span').text(fourtyEightAPR);
              $("div.fourty-eight-month").animate({
                opacity: 1,
              }, 200, function () {
                  $('.fourty-eight-month').parent('div').removeClass('d-none');
              });
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            //console.log("48mo. Status: " + textStatus); alert("Error: " + errorThrown);
          }
        });


        // 60 Months
        $.ajax({
          type: "POST",
          url: "https://www.tayloegray.com/ls/feed.php",
          dataType: "json",
          data: {
            term: "60",
            purpose: rateTypeVar,
            amount: modAmountVar
          },
          success: function (result) {
            if (result.IsValid == "true") {
              var sixtyPayment = Math.round(result.EstimatedMonthPayment.From);
              var sixtyAPR = (result.Rate.From * 100).toFixed(2);
              $('div.sixty-month .payment-amount').find('strong').text(sixtyPayment);
              $('div.sixty-month .apr').find('span').text(sixtyAPR);
              $("div.sixty-month").animate({
                opacity: 1,
              }, 200, function () {
                  $('.sixty-month').parent('div').removeClass('d-none');
                  $('.lightstream-rate-form-container .lightstream-loader').css('display', 'none');
              });
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            //console.log("60mo. Status: " + textStatus); alert("Error: " + errorThrown);
          }
        });


        // 72 Months
        $.ajax({
          type: "POST",
          url: "https://www.tayloegray.com/ls/feed.php",
          dataType: "json",
          data: {
            term: "72",
            purpose: rateTypeVar,
            amount: modAmountVar
          },
          success: function (result) {
            if (result.IsValid == "true") {
              var seventyTwoPayment = Math.round(result.EstimatedMonthPayment.From);
              var seventyTwoAPR = (result.Rate.From * 100).toFixed(2);
              $('div.seventy-two-month .payment-amount').find('strong').text(seventyTwoPayment);
              $('div.seventy-two-month .apr').find('span').text(seventyTwoAPR);
              $("div.seventy-two-month").animate({
                opacity: 1,
              }, 200, function () {
                  $('.seventy-two-month').parent('div').removeClass('d-none');
                  $('.lightstream-rate-form-container .lightstream-loader').css('display', 'none');
              });
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            //console.log("72mo. Status: " + textStatus); alert("Error: " + errorThrown);
          }
        });


        // 84 Months
        $.ajax({
          type: "POST",
          url: "https://www.tayloegray.com/ls/feed.php",
          dataType: "json",
          data: {
            term: "84",
            purpose: rateTypeVar,
            amount: modAmountVar
          },
          success: function (result) {
            if (result.IsValid == "true") {
              var eightyPayment = Math.round(result.EstimatedMonthPayment.From);
              var eightyAPR = (result.Rate.From * 100).toFixed(2);
              $('div.eighty-four-month .payment-amount').find('strong').text(eightyPayment);
              $('div.eighty-four-month .apr').find('span').text(eightyAPR);
              $("div.eighty-four-month").animate({
                opacity: 1,
              }, 200, function () {
                  $('.eighty-four-month').parent('div').removeClass('d-none');
                  $('.lightstream-rate-form-container .lightstream-loader').css('display', 'none');
              });
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            //console.log("84mo. Status: " + textStatus); alert("Error: " + errorThrown);
          }
        });


        // 144 Months
        $.ajax({
          type: "POST",
          url: "https://www.tayloegray.com/ls/feed.php",
          dataType: "json",
          data: {
            term: "144",
            purpose: rateTypeVar,
            amount: modAmountVar
          },
          success: function (result) {
            if (result.IsValid == "true") {
              var oneFortyFourPayment = Math.round(result.EstimatedMonthPayment.From);
              var oneFortyFourAPR = (result.Rate.From * 100).toFixed(2);
              $('div.one-forty-four-month .payment-amount').find('strong').text(oneFortyFourPayment);
              $('div.one-forty-four-month .apr').find('span').text(oneFortyFourAPR);
              $("div.one-forty-four-month").animate({
                opacity: 1,
              }, 200, function () {
                  $('.one-forty-four-month').parent('div').removeClass('d-none');
                  $('.lightstream-rate-form-container .lightstream-loader').css('display', 'none');
              });
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            //console.log("144mo. Status: " + textStatus); alert("Error: " + errorThrown);
          }
        });


        var disclaimer = "* Estimated payment is based on the lowest APR. Exact rate is determined by credit profile.";

        // Disclaimer
        $('.rates-disclaimer').text(disclaimer);

        $('.rate-form-content, .lightstream-rate-form').hide();
        $('.loan-type-title').text(rateType);
        $('.loan-amount-return-message').text(rateAmount + " " + rateType).fadeIn();
        $('.lightstream-rate-results').fadeIn();

      } else {

        if (typeValidated === false) {

          $('.lightstream-rate-form-message').append('<span>You must select a Loan Purpose.</span>');

        }

        if (amountValidated === false) {

          $('.lightstream-rate-form-message').append('<span>Please enter an amount between $5,000.00 and $100,000.00.</span>');

        }

      }
    });

    $('.recalculate-rates').on("click", function(e) {
      e.preventDefault();
      $('.lightstream-rate-results .row.justify-content-center .col-lg-3').addClass('d-none');
      $('.lightstream-rate-form-message').html("");
      $('.loan-amount-return-message, .lightstream-rate-results').hide();
      $('.rate-form-content, .lightstream-rate-form').show();
      $('html,body').animate({
        scrollTop: $('#rates-calculator').offset().top
      }, 400, function () {
      });
    });

  });
})(window, document, jQuery);
